module.exports = __webpack_public_path__ + "img/course70_summary_unit_timelines.a87b4199.jpg";